// assets/js/gsap.js

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  // Fade Up group
  gsap.utils.toArray(".fade-group").forEach((group) => {
    const items = group.querySelectorAll(".fade-up");

    gsap.from(items, {
      y: 40,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      stagger: 0.2,
      scrollTrigger: {
        trigger: group,
        start: "top 85%",
        once: true,
      },
    });
  });

  // Fade Up single
  gsap.utils.toArray(".fade-up").forEach((el) => {
    if (el.closest(".fade-group")) return;

    gsap.from(el, {
      y: 40,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },
    });
  });

  // Fade Left
  gsap.utils.toArray(".fade-left").forEach((el) => {
    gsap.from(el, {
      x: -40,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },
    });
  });

  // Fade Right
  gsap.utils.toArray(".fade-right").forEach((el) => {
    gsap.from(el, {
      x: 40,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },
    });
  });

  ScrollTrigger.refresh();
});